import React, { FC } from 'react';
import { ImageContainer, Name, Text, Position, Flip, ContentCard, Talk, TalkContainer } from './styled';
import { UserBio } from 'types';
import { useTranslation } from 'react-i18next';
import { Icon } from 'kl-b2c-ui-kit';
import DOMPurify from 'dompurify';

export const UserBioFront: FC<UserBio> = ({
    name,
    position,
    twitter,
    image,
    description,
    nameOfReport,
    event,
    setOpenedIds,
}) => {
    const { t } = useTranslation('pages/home');

    return (
        <ContentCard>
            <ImageContainer background={image} />
            <Text>
                <Name>{name}</Name>
                <Position>{position}</Position>
                {nameOfReport && (
                    <TalkContainer
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();

                            if (setOpenedIds && event) {
                                setOpenedIds(event?.id);
                            }
                        }}
                    >
                        <Talk>{t('talk')}</Talk>
                        &nbsp;
                        <Talk
                            isGreen
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(nameOfReport),
                            }}
                        />
                    </TalkContainer>
                )}
                {(twitter || description) && (
                    <Flip>
                        <span>{t('flip')}</span>
                        <Icon name={'Refresh'} size={18} color="teal" />
                    </Flip>
                )}
            </Text>
        </ContentCard>
    );
};
